(function($, undefined) {
	
	'use strict';
	var form;
	var formValidator;
	const CREATE_TEACHER_EMAIL_SUBJECT = "Votre nouveau compte sur CSRS";
	
	var validateTeacherFormBeforeSubmit = function() {
		var thisForm = $(this);
		formValidator.validateForm(thisForm);
		
		if (thisForm.hasClass('has-error')) {
			return false;
		}
	};
	
	var submitCreateTeacherForm = function() {
		var btn = $(this);
		var thisForm = btn.closest('form');
		
		formValidator.validateForm(thisForm);
		
		if (!thisForm.hasClass('has-error')) {
			var password = $('input[name=password]', thisForm).val();
			var firstName = $('input[name=firstName]', thisForm).val();
			var lastName = $('input[name=lastName]', thisForm).val();
			var email = $('input[name=email]', thisForm).val();
			var field1 = $('input[name=field1]', thisForm).val();
			var field2 = $('[name=field2]', thisForm).val();
			
			var params = {
				returnId: true,
				ajax: true,
				password: password,
				firstName: firstName,
				lastName: lastName,
				email: email,
				field1: field1,
				field2: field2
			};
			
			console.log(params);
			
			$.ajax({
				url: "/action/createAccount",
				method: "post",
				data: params,
				success: function(response) {
					console.log(response);
					if (response.indexOf('success') !== -1) {
						var personId = response.replace('success-', '').trim();
						sendCreateTeacherEmail(personId, email, password);
					}	
				},
				error: function(jqxhr, status, error) {
					console.log(status + " " + error);
				}
			});
		}
	};
	
	var sendCreateTeacherEmail = function(personId, email, password) {
		var params = {
			file: "create-teacher",
			subject: CREATE_TEACHER_EMAIL_SUBJECT,
			email: email,
			personId: personId,
			field1: password
		};
		$.ajax({
			url: "/action/sendEmail",
			method: "post",
			data: params,
			success: function(response) {
				console.log(response);
				location.reload();
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		form = $('.teacher-info-form');
		
		form.on('submit', validateTeacherFormBeforeSubmit);
		$('.form-add-teacher-btn[type=button]', form).on('click', submitCreateTeacherForm);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
